import { OwnerRoute, RequireOrganization } from "../components/ProtectedRoute";
import { DashboardLayout } from "../components/DashboardLayout";

export default [OwnerRoute, RequireOrganization, DashboardLayout];